import { formatToPageHeadline } from 'helpers/date';
import Logo from 'components/atoms/Logo/Logo';
import { Translate } from 'next-translate';

interface GetPdfContentProps {
  items: any;
  date: string | undefined;
}

type MockItem = any;

interface ItemsByCat {
  [key: string]: any;
}

export const getPdfData = ({ items, date }: GetPdfContentProps, t: Translate): JSX.Element => {
  const itemsByCat: ItemsByCat = {
    all: [],
  };
  items.forEach((item: any) => {
    if (item.category) {
      if (item.category in itemsByCat) {
        itemsByCat[item.category].push(item);
      } else {
        itemsByCat[item.category] = [item];
      }
    } else {
      itemsByCat.all.push(item);
    }
  });

  return (
    <>
      <div className="logo-wrapper">
        <Logo />
      </div>
      <h1>
        {t('dailyPlan')} {date && formatToPageHeadline(date)}
      </h1>

      {Object.keys(itemsByCat)
        .filter((itemsGroupKey) => {
          return itemsByCat[itemsGroupKey].length > 0;
        })
        .map((itemsGroupKey, itemCatIdx) => {
          return (
            <table key={`table-pdf-${itemCatIdx}-${t('dailyPlan')}`}>
              <thead>
                <tr>
                  <th>{t(itemsGroupKey)}</th>
                  <th>{t('houseNr')}</th>
                  <th>{t('time')}</th>
                </tr>
              </thead>
              <tbody>
                {itemsByCat[itemsGroupKey] &&
                  itemsByCat[itemsGroupKey].map((item: MockItem, index: number) => {
                    return (
                      <tr key={`list_${itemCatIdx}-${index}`}>
                        <td>{item.display_name}</td>
                        <td>{item.termin.location?.house_nr}</td>
                        <td>{item.termin.timeslot}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          );
        })}
    </>
  );
};
